module.exports = __webpack_public_path__ + "img/45_bohle.5200f63d.jpeg";